import { nameShape } from "@logic/lib/2d"
import type { Edge2d } from "@logic/lib/mesh"
import { selector } from "recoil"

import type { TransactionOperation } from "."
import { edgeIndex, findEdgeState } from "../edges"
import {
  getNodeSelectionState,
  lastOf,
  nodeSelectionState,
} from "../nodeSelection"
import type { EdgeActionTo_, EdgeChangeTo_ } from "../timeline"
import { generateElementChange } from "../timeline/transactions"

export const addEdge: TransactionOperation<
  { id: string; payload: Edge2d },
  EdgeChangeTo_[`CREATE`]
> = (transactors, { id, payload }) => {
  console.debug(`addEdge`, id, JSON.stringify(payload))
  const { get, set } = transactors
  // const { setbacks } = get(designLocalState)
  set(findEdgeState(id), (current) => ({
    ...current,
    ...payload,
  }))
  set(edgeIndex, (s) => [...s, id])
  const action: EdgeActionTo_[`CREATE`] = {
    type: `CREATE`,
    family: `EDGE`,
    id,
  }

  return generateElementChange(transactors, {
    action,
  }) as EdgeChangeTo_[`CREATE`]
}

export const tryToAddEdge: TransactionOperation<
  string,
  EdgeChangeTo_[`CREATE`] | void
> = (transactors, node2id) => {
  const { get } = transactors
  const nodeSelection = getNodeSelectionState(transactors)
  const node1id = lastOf(nodeSelection)
  if (node1id && node1id !== node2id) {
    const newEdgeId = nameShape(node1id, node2id)
    const edgeExists = get(edgeIndex).includes(newEdgeId)
    if (!edgeExists) {
      return addEdge(transactors, {
        id: newEdgeId,
        payload: { node1id, node2id },
      })
    }
  } else if (node1id === node2id) {
    console.warn(`Attempted to add edge connecting node to itself`)
  }
}
